import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import Button from "react-bootstrap/Button";
import { styled } from "@mui/system";
import {
  ModalSuccessLogo,
  ModalBottomLogo,
  ModalFailureLogo,
} from "../assets/icons";
import {
  DISPLAY_BLOCK,
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_CENTER,
  MAX_WIDTH,
  TEXT_ALIGN_CENTER,
} from "../config/styles";
import { Typography } from "@mui/material";
import { colors } from "../config/colors";

export const CUSTOM_MODAL_TYPES = {
  SUCCESS: "success",
  FAILURE: "failure",
};

const CustomModalStyled = styled(Modal, {
  shouldForwardProp: (prop) => prop !== "modalType",
})(({ theme, modalType }) => ({
  width: "408px",
  margin: "0 auto",
  "& .custom-modal": {
    width: "408px !important",
    margin: "0 auto !important",
  },
  "& .modal-header": {
    borderBottom: "none",
    backgroundColor:
      modalType === CUSTOM_MODAL_TYPES.SUCCESS
        ? theme.palette.primary.main
        : theme.palette.secondary.contrastText,
    height: "159px",
    alignItems: "start",
    display: DISPLAY_BLOCK,
  },
  "& .modal-header-wrapper": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    width: MAX_WIDTH,
    paddingTop: "8px",
  },
  "& .modal-body": {
    padding: "20px",
    textAlign: "center",
    fontSize: "16px",
    color: theme.palette.text.primary,
  },
  "& .button-style": {
    width: "360px",
    margin: "24px auto",
    padding: "8px 16px",
    gap: "8px",
    height: "36px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "bold",
    border: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export const CustomModal = ({
  show,
  onHide,
  title,
  message,
  modalType = "success",
}) => {
  return (
    <CustomModalStyled
      show={show}
      onHide={onHide}
      centered
      contentClassName="custom-modal"
      modalType={modalType}
    >
      <Modal.Header bsPrefix="modal-header">
        <div className="d-flex justify-content-end w-100">
          <CloseButton
            variant={
              modalType === CUSTOM_MODAL_TYPES.SUCCESS ? "white" : "dark"
            }
            onClick={onHide}
          />
        </div>
        <div className="modal-header-wrapper">
          {modalType === CUSTOM_MODAL_TYPES.SUCCESS ? (
            <ModalSuccessLogo />
          ) : (
            <ModalFailureLogo />
          )}
        </div>
        <div style={{ marginTop: "48px", textAlign: TEXT_ALIGN_CENTER }}>
          <ModalBottomLogo />
        </div>
      </Modal.Header>

      <Modal.Body className="py-4">
        <Typography variant="body2" className="w-100 ">
          {title}
        </Typography>
        <Typography
          variant="subitle2"
          className="w-100 mt-3"
          component="p"
          sx={{ color: colors.grayLight }}
        >
          {message}
        </Typography>
      </Modal.Body>
      <Button className="button-style" onClick={onHide}>
        Done
      </Button>
    </CustomModalStyled>
  );
};
CustomModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  modalType: PropTypes.string,
};
